import classNames from 'classnames';
import React, { forwardRef } from 'react';

export interface NavLinkProps extends React.AnchorHTMLAttributes<HTMLElement> {
  tag?: React.ElementType;
  innerRef?: React.Ref<HTMLElement>;
  disabled?: boolean;
  active?: boolean;
  href?: string;
  [key: string]: any;
}

const NavLink = forwardRef<HTMLElement, NavLinkProps>((props, ref) => {
  const { className, active, tag: Tag = 'a', innerRef, onClick, disabled, href, ...attributes } = props;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (href === '#') {
      e.preventDefault();
    }
    if (onClick) {
      onClick(e as React.MouseEvent<HTMLAnchorElement>);
    }
  };

  const classes = classNames(className, 'nav-link', { disabled, active });

  return (
    <Tag
      {...attributes}
      href={href}
      ref={innerRef ?? ref}
      onClick={handleClick}
      className={classes}
    />
  );
});

NavLink.displayName = 'NavLink';

export default NavLink;
